import { useContext } from 'react';
import Styles from './ConfirmationCard.module.scss'
import { Backdrop, Typography, Divider } from '@mui/material';
import { ViewContext } from 'components/lib';

/**
 * shows a generic confirmation card
 * @param {string} title the title shown on top of the card
 * @param {string} body the body text
 * @param {boolean} showCard state var true/false indicating if the card has to be shown
 * @param {function} setShowCard setState function that controls the showCard
 * @param {function} handleCancel function to execute on cancel, showCard is set to false after executing
 * @param {function} handleConfirm function to execute on confirm, showCard is set to false after executing
 * @param {boolean} destructive sets button style to delete action
 * @param {Object} args object passed to handleConfirm function
 * @param {string} confirmButtonText overrides default confirm button text
 * @param {string} cancelButtonText overrides default cancel button text
 * @returns 
 */
export function ConfirmationCard({ title, body, showCard, setShowCard, handleCancel = null,
    handleConfirm, destructive = false, args, moduleCard = false, lectureCard = false, 
    showOptions = false, handleDeleteAssociation, handleLectureAssociation, confirmButtonText,
    cancelButtonText
}) {
    const hideConfirmCard = () => {
        setShowCard(false);
    }

    const viewContext = useContext(ViewContext);

    const handleConfirmation = () => {
        if (args?.length > 0) {
            return handleConfirm(...args);
        } else {
            return handleConfirm({});
        }
    };

    const handleCancelClick = () => {
        if (handleCancel) {
            return handleCancel();
        } else {
            return hideConfirmCard();
        }
    };

    const handleModuleAssociation = () => {
        if (args?.length > 0) {
            return handleDeleteAssociation(...args);
        } else {
            return handleDeleteAssociation();
        }
    }

    const handleLectureDeletion = () => {
        if (args?.length > 0) {
            return handleLectureAssociation(...args);
        } else {
            return handleLectureAssociation();
        }
    }

    // TODO third button related code needs to be not hard coded and passed from the parent component

    return (
        <>
            {showCard &&
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={showCard}
                    invisible={false}
                >
                    <div tabIndex={-1} id='cardContainer' className={`${Styles.cardContainer} ${moduleCard || lectureCard ? Styles.widerCard : ''}`}>
                        <div
                            id='confirmTitle'
                            aria-label={title}
                            className={Styles.confirmTitle}
                        >
                            <Typography variant='h5'>
                                {title.toUpperCase()}
                            </Typography>
                        </div>
                        <Divider />
                        <div
                            id='confirmBody'
                            className={Styles.confirmBody}
                        >
                            {body}
                        </div>
                        <div
                            id='buttonHolders'
                            className={Styles.buttonHolders}
                        >
                            <button
                                id='cancelbutton'
                                className={Styles.cancelbutton}
                                onClick={() => {
                                    handleCancelClick();
                                }}
                            >
                                { cancelButtonText ||viewContext.t('Components.ConfirmationCard.button.cancel')}
                            </button>
                            
                            {showOptions && (moduleCard || lectureCard) && (
                                <button
                                    id='deletePermanentlyButton'
                                    className={Styles.confirmbutton}
                                    style={{ backgroundColor: destructive ? '#FF1616' : "" }}
                                    onClick={() => {
                                        if (moduleCard) {
                                            handleModuleAssociation();
                                        } else if (lectureCard) {
                                            handleLectureDeletion();
                                        }
                                        hideConfirmCard();
                                    }}
                                >
                                    {moduleCard ? "From this course" : "From this module"}
                                </button>
                            )}

                            {(moduleCard || lectureCard) && (
                                <button
                                    id='confirmbutton'
                                    className={Styles.confirmbutton}
                                    style={{ backgroundColor: destructive ? '#FF1616' : "" }}
                                    onClick={() => {
                                        if (showOptions) {
                                            handleConfirmation();
                                        } else {
                                            moduleCard ? handleModuleAssociation() : handleLectureDeletion();
                                        }
                                        hideConfirmCard();
                                    }}
                                >
                                    {showOptions ? "Permanently" : "Confirm"}
                                </button>
                            )}

                            {(!moduleCard && !lectureCard && !showOptions) && (
                                <button id='confirmbutton'
                                    className={Styles.confirmbutton}
                                    style={{ backgroundColor: destructive ? '#FF1616' : "" }}
                                    onClick={() => {
                                        handleConfirmation();
                                        hideConfirmCard();
                                    }}>
                                    { confirmButtonText || viewContext.t('Components.ConfirmationCard.button.confirm')}
                                </button>
                            )}
                        </div>
                    </div>
                </Backdrop>
            }
        </>
    );

}

